import { render, staticRenderFns } from "./sameStyle.vue?vue&type=template&id=20818421&scoped=true&"
import script from "./sameStyle.ts?vue&type=script&lang=js&"
export * from "./sameStyle.ts?vue&type=script&lang=js&"
import style0 from "./sameStyle.less?vue&type=style&index=0&id=20818421&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20818421",
  null
  
)

export default component.exports